/* @flow weak */
import React from 'react';

import BoxBody from 'components/BoxBody.jsx';
import BoxFooter from 'components/BoxFooter.jsx';
import Button from 'components/Button.jsx';
import CurrentUser from 'auth/CurrentUser';
import DialogContent from 'components/DialogContent.jsx';
import FeatureStore from 'stores/FeatureStore';
import Form from 'components/Form.jsx';
import FormCheckBox from 'components/FormCheckBox.jsx';
import FormInput from 'components/FormInput.jsx';
import Group from 'entities/Group';
import GroupActions from 'groups/actions/GroupActions';
import GroupStore from 'groups/stores/GroupStore';
import Image from 'components/Image.jsx';
import Link from 'components/Link.jsx';
import PromptActions from 'actions/PromptActions';
import PromptStore from 'stores/PromptStore';
import { PromptNames } from 'constants/PromptConstants';
import ToastActions from 'actions/ToastActions';
import UserActions from 'user/UserActions';

import './styles/SetupGroup.scss';

const FACEBOOK_TRACKING_PIXEL =
  'https://www.facebook.com/offsite_event.php?id=6008327779772&value=0.01&currency=USD';

const SetupGroup = React.createClass({
  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  getInitialState() {
    return {
      submitEnabled: false,
    };
  },

  handleSubmit(data) {
    this.setState({ submitEnabled: false });

    const { groupName, overThirteen } = data;

    const groupToCreate = new Group();
    groupToCreate.setName(groupName);
    groupToCreate.setHasChildren(!overThirteen);
    groupToCreate.setCanSubscribersInititateChats(
      FeatureStore.hasFeature('subscriber_initiated_chats_default')
    );

    const onError = (error) => {
      this.setState({ submitEnabled: true });
      ToastActions.showAPIError(error);
    };

    GroupActions.create(groupToCreate).then(group => {
      // Controls visibility of group invite modal when landing in app
      GroupStore.setGroupCreatedDuringSetup(group);

      if (!PromptStore.hasDismissed(PromptNames.NUX_SETUP_CLASS)) {
        PromptActions.recordDismissal(PromptNames.NUX_SETUP_CLASS).then(() => {
          UserActions.loadCurrentUser();
        }).catch(error => console.error('SetupGroup - can‘t record NUX_SETUP_CLASS dismissal', error));
      }
      this.context.router.push('/classes/?origin=created_group');
    }, onError);
  },

  onInputBlur(event) {
    // Hack to redirect before firing validation if the thing that was clicked on the
    // cause the blur was a link to somewhere else
    if (event.relatedTarget &&
      event.relatedTarget.href &&
      event.relatedTarget.href.endsWith('/setup/subscriptions')) {
      this.context.router.push('/setup/subscriptions');
    }
  },

  validateClassName(e) {
    const value = e.target.value;

    let warning = null;

    if (value === '81010' || value.startsWith('@') || value.startsWith('rmd.me')) {
      warning = (
        <div>
          {'It looks like you’re trying to '}
          <Link
            className="SetupGroup-warning"
            to="/setup/subscriptions"
            eventElementName="SetupGroup-warning">join a class</Link>.
        </div>
      );
    }

    this.setState({ warning });
  },

  renderFBTrackingPixel() {
    // Don't render the tracking pixel for subsequent logins
    if (CurrentUser.getUser().getSignInCount() > 1) {
      return null;
    }

    return (
      <Image
        className="SetupGroup-fbPixel"
        src={FACEBOOK_TRACKING_PIXEL}
        width="1"
        height="1"
      />
    );
  },

  renderUnder13Checkbox() {
    return (
      <FormCheckBox name="overThirteen" defaultChecked>
        <div>
          I will only message people 13 and older
        </div>
        <div className="SetupGroup-labelSubtext">
          It’s okay if students are under 13. We’ll ask for a parent’s
           email address to keep everyone in the loop.
        </div>
      </FormCheckBox>
    );
  },

  render() {
    const props = {
      title: 'Create a class',
      subtext:
        `Once you create a class, you can invite students and parents,
         send announcements, and start conversations.`,
      size: 'small',
    };

    return (
      <DialogContent {...props} full className="SetupGroup">
        <BoxBody divided>
          <Form
            onValidSubmit={this.handleSubmit}
            onValid={() => this.setState({ submitEnabled: true })}
            onInvalid={() => this.setState({ submitEnabled: false })}>
            <FormInput
              label="Class name"
              onBlur={this.onInputBlur}
              onChange={this.validateClassName}
              required
              className="SetupGroup-GroupName"
              type="text"
              name="groupName"
              placeholder="e.g. Math 101, Soccer Team, Chess Club"
              autofocus
              showErrorAfterBlur
              warning={this.state.warning}
              validations={{ minLength: 3, maxLength: 60 }}
              validationError="The class name must be between 3 and 60 characters long."
            />
            {
              CurrentUser.getUser().isTeacher() ?
                this.renderUnder13Checkbox() :
                <div>
                  <FormInput type="hidden" name="overThirteen" value />
                  <p className="SetupGroup-overThirteenText">
                    This class can only include people who are 13 or older.
                  </p>
                </div>
            }

            <Button
              className="SetupGroup-button-submit"
              disabled={!this.state.submitEnabled}
              type="submit"
              level="primary"
              eventElementName="SetupGroup-button-submit">
              Add
            </Button>
          </Form>
        </BoxBody>
        <BoxFooter>
          {'Looking for a class? '}
          <Link
            className="SetupGroup-JoinClass"
            onClick={() => this.context.router.push('/setup/subscriptions')}
            eventElementName="SetupGroup-JoinClass">
            Join a class
          </Link>
        </BoxFooter>
        {this.renderFBTrackingPixel()}
      </DialogContent>
    );
  },
});

export default SetupGroup;



// WEBPACK FOOTER //
// ./src/setup/components/SetupGroup.jsx